export const initRumTracker = function (config) {
  const isTrackerDisabled = process.env.NODE_ENV === 'development' || !config.rumEnabled;
  if (isTrackerDisabled) return;

  // Site 24x7 RUM tracker
  // https://seopa01.atlassian.net/browse/SU-3987
  // RUM monitor setup for spa - https://www.site24x7.com/help/apm/rum/add-rum-monitor-for-spa.html
  /* eslint-disable */
  (function (w, d, s, r, k, h, m) {
    if (w.performance && w.performance.timing && w.performance.navigation) {
      w[r] = w[r] || function () { (w[r].q = w[r].q || []).push(arguments); };
      h = d.createElement('script'); h.async = true; h.setAttribute('src', s + k);
      d.getElementsByTagName('head')[0].appendChild(h);
      (m = window.onerror), (window.onerror = function (b, c, d, f, g) {
        m && m(b, c, d, f, g), g || (g = new Error(b)), (w[r].q = w[r].q || []).push(['captureException', g]);
      });
    }
  })(window, document, '//static.site24x7rum.com/beacon/site24x7rum-min.js?appKey=', 's247r', 'a5bff0e24afd57e17a9ad495db25b453');
  /* eslint-enable */
};
